import React from 'react';
import PropTypes from 'prop-types';
import { QuoteCustomLineItem } from '../../../quotes/otherQuoteEntities';
import BuildToOrderLeadTimeLabel from '../../../quotes/lead-times/BuildToOrderLeadTimeLabel';
import ReviewQuoteCustomLineItemPricing from '../quote-products/ReviewQuoteCustomLineItemPricing';

export default class ReviewQuoteCustomLineItem extends React.PureComponent {
  static propTypes = {
    item: PropTypes.instanceOf(QuoteCustomLineItem).isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    onQuantityUpdated: PropTypes.func.isRequired,
    msrpClassNames: PropTypes.string.isRequired,
    dNetClassNames: PropTypes.string.isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
    isoCurrencySymbol: PropTypes.string.isRequired,
    onAddOverrideDiscount: PropTypes.func.isRequired,
    onEditOverrideDiscount: PropTypes.func.isRequired,
    onRemoveOverrideDiscount: PropTypes.func.isRequired
  };

  render() {
    const {
      item,
      selectedPriceMode,
      readOnly,
      msrpClassNames,
      dNetClassNames,
      isoCurrencySymbol,
      onQuantityUpdated,
      onAddOverrideDiscount,
      onEditOverrideDiscount,
      onRemoveOverrideDiscount
    } = this.props;

    return (
      <tr>
        <td className="text-start">
          <div className="item-name">{item.name}</div>
          <div>{item.basePartNumber}</div>
          <div className="text-break-line">{item.description}</div>
          {!readOnly && (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => this.props.onEdit(item)}
              >
                edit
              </button>
              <button
                className="btn btn-link text-danger p-0 ms-3"
                type="button"
                onClick={() => this.props.onRemove(item.id)}
              >
                remove
              </button>
            </React.Fragment>
          )}
        </td>
        <td data-title="Lead Time" className="lead-time">
          {item.leadTimeDays ? (
            <BuildToOrderLeadTimeLabel leadTimeDays={item.leadTimeDays} />
          ) : (
            'n/a'
          )}
        </td>
        <td className="price-breakdown">
          {item.pricing && <ReviewQuoteCustomLineItemPricing
            pricing={item.pricing}
            selectedPriceMode={selectedPriceMode}
            isoCurrencySymbol={isoCurrencySymbol}
            msrpClassNames={msrpClassNames}
            dNetClassNames={dNetClassNames}
            quoteCustomLineItem={item}
            onQuantityUpdated={onQuantityUpdated}
            onAddOverrideDiscount={onAddOverrideDiscount}
            onEditOverrideDiscount={onEditOverrideDiscount}
            onRemoveOverrideDiscount={onRemoveOverrideDiscount}
          />}
        </td>
      </tr>
    );
  }
}
